module.exports = __webpack_public_path__ + "media/images/home/mission_bg-c36283dce7fa1ec0b9f89f2ed93c09fa.jpg";